<template>
  <div>


    <div class="container-fluid ">
      <div class="">
      
      
	    <div  id="pdfDocument"></div>

       
      </div>
      <!-- End row-->

      <!--start new row-->
     




    
    </div>  <!--End container-->
    
      <div  id="pdfDocumentDownloadLink" style="text-align:center;margin-bottom:50px;font-weight:bold;margin-top:20px;"></div>
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  
    },
    data() {
      return {
     	 officers:[],
	
      };
    },
    methods: {
      initBigChart(index) {

      }
    },
    mounted() {
      	swal.showLoading();
      	let uri = this.$base_url+'/api/v1/c/get_mail/'+ this.$route.params.mid;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 let file = response.data.document;
			this.doc = response.data.doc_obj;
				
		
				if(this.doc.format=="pdf"){
					let b64 = file;
				
					// Embed the PDF into the HTML page and show it to the user
					var obj = document.createElement('object');
					obj.style.width = '100%';
					obj.style.height = '842pt';
					obj.type = 'application/pdf';
					obj.data = 'data:application/pdf;base64,' + b64;
					document.getElementById("pdfDocument").appendChild(obj);
					
					// Insert a link that allows the user to download the PDF file
					var link = document.createElement('a');
					link.innerHTML = 'Download PDF file';
					link.download = 'easily_document.pdf';
					link.href = 'data:application/octet-stream;base64,' + b64;
					 document.getElementById("pdfDocumentDownloadLink").appendChild(link);
					
				}
				else if(this.doc.format=="jpeg" || this.doc.format=="jpg" || this.doc.format=="png"){
					let b64 = file;
				
					var obj = document.createElement('object');
					obj.style.width = '100%';
					obj.style.height = '842pt';
					obj.type = 'application/'+this.doc.format;
					obj.src = 'data:image/jpeg;base64,,' + b64;
					
					
					var img = document.createElement("img");
					img.src = 'data:image/'+this.doc.format+';base64,'+b64
					document.getElementById("pdfDocument").append(img);
					
					
					
					// Insert a link that allows the user to download the PDF file
				/*	var link = document.createElement('a');
					link.innerHTML = 'Download file';
					link.download = this.coy.uen+'_document.'+this.doc.format;
					link.href = 'data:application/octet-stream;base64,' + b64;
					document.getElementById("pdfDocumentDownloadLink").appendChild(link);
					*/
				}
				swal.close();
   
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














